import { ProcessedDocumentControlModel } from "./ProcessedDocumentControlModel";
import { ProcessedDocumentSuggestionModel } from "./ProcessedDocumentSuggestionModel";

export class ProcessedDocumentRiskModel extends ProcessedDocumentSuggestionModel {
    controls: ProcessedDocumentControlModel[];
    hasLinkedRisks?: boolean;
}
